import { render, staticRenderFns } from "./ProductEansTable.vue?vue&type=template&id=09607838"
import script from "./ProductEansTable.vue?vue&type=script&lang=js"
export * from "./ProductEansTable.vue?vue&type=script&lang=js"
import style0 from "./ProductEansTable.vue?vue&type=style&index=0&id=09607838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports